import api from './api';
import type { AccidentEvaluationResponse } from '../types/accidentEvaluation';

const ACCIDENT_EVALUATION_PATH = '/api/accident-evaluation';

/**
 * API-Client fuer die Unfalldaten-Auswertung (Plan 21-03/21-05/21-06). Der Endpoint liefert
 * ein handgebautes Objekt, keine API-Platform-Collection -- deshalb keine Hydra-Extraktion
 * (anders als die uebrigen Auswertungs-Clients in evaluationsApi.ts).
 */
export const accidentEvaluationApi = {
  getAll: async (year?: number): Promise<AccidentEvaluationResponse> => {
    const query = year !== undefined ? `?year=${year}` : '';
    const response = await api.get<AccidentEvaluationResponse>(`${ACCIDENT_EVALUATION_PATH}${query}`);
    return response.data;
  },

  /**
   * Laedt die XLSX-Exportdatei fuer ein Jahr. Laeuft ueber die JWT-tragende Axios-Instanz --
   * ein rohes <a href> wuerde keinen Authorization-Header mitschicken und mit 401 scheitern.
   * Der Dateiname wird vom Aufrufer client-seitig aus dem bekannten Jahr gebaut (Pitfall 4:
   * Content-Disposition ist per CORS nicht lesbar, nelmio_cors exponiert nur 'Link').
   */
  export: async (year: number): Promise<Blob> => {
    const response = await api.get<Blob>(`${ACCIDENT_EVALUATION_PATH}/export?year=${year}`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
